import { useEffect, useState } from 'preact/hooks';

const Glitch = (props) => {

    const [state, setState] = useState(props.children);
    const interval = () => { return (Math.floor(Math.random() * (25 - 3 + 1)) + 3) * 1000};
    let timeout = null;
    let timerID = null;
    let opened = false;
    useEffect(() => {
        if (props.enabled) {
            timerID = setTimeout(() => tick(), interval());
        }
        return function cleanup() {
            clearTimeout(timerID);
            clearTimeout(timeout);
        };
    }, []);

    const glitched = props.blockedText ? props.blockedText : '???????';

    function tick() {
        if (typeof props.children !== 'string'){
            for (let i = 0; i < props.children.length; i++) {
                let child = props.children[i];
                if (child.props && child.props.openedLink) {
                    opened = true;
                }
            }
        }

        if (!opened) {
            setState(glitched);
            opened = false;
            timeout = setTimeout(() => {
                setState(props.children);
                clearTimeout(timerID);
                clearTimeout(timeout);
                timerID = setTimeout(() => tick(), interval());
            }, 5000);
        } else {
            opened = false;
            timerID = setTimeout(() => tick(), interval());
        }
    }
    return (
        <>
            {state}
        </>
    )
}

export default Glitch;
